export const styles = ({
    phone: {
        width: '100%',
        height: 'auto'
    }
});
